const styles = theme => ({
  tableCell: {
    width: '25%',
    '&:nth-of-type(2)': {
      paddingRight: 15,
    },
    '&:nth-of-type(3)': {
      paddingLeft: 15,
    },
  },
  tableFooter: {
    backgroundColor: 'rgb(249, 249, 249)',
  },
  summary: {
    marginTop: 16,
    background: 'rgb(216, 220, 223)',
    padding: 8,
  },
  noWrap: {
    whiteSpace: 'nowrap'
  },
  ellipsisXs: {},
  hideXs: {},
  blockXs: {},
  showXs: {
    display: 'none'
  },
  [theme.breakpoints.down('sm')]: {
    summary: {
      fontSize: 12,
      marginTop: 10,
      padding: 5
    },
  },
  [theme.breakpoints.only('xs')]: {
    tableCell: {
      width: '50%',
      padding: 5,
      '&:nth-of-type(1)': {
        paddingRight: 10,
      },
      '&:nth-of-type(2)': {
        paddingLeft: 10,
      },
    },
    hideXs: {
      display: 'none'
    },
    showXs: {
      display: 'initial'
    },
    blockXs: {
      display: 'block',
    },
    ellipsisXs: {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      cursor: 'pointer',
      '&:hover': {
        textOverflow: 'initial',
        overflow: 'initial',
        whiteSpace: 'initial',
        wordBreak: 'break-all'
      }
    },
  },
});
export default styles;